module.exports = __webpack_public_path__ + "img/enable-2.554676d9.jpg";